var map = {
	"./en/card_5_1.png": "Ut1A",
	"./es/card_5_1.png": "ET8w",
	"./pt/card_5_1.png": "2AzN"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "eR/p";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*\/card_5_1\.png$
// module id = eR/p
// module chunks = 0